import $ from 'jquery';
import getUsers from '../api/get-users';

$(() => {
    if (window.loggedIn) {
        getUsers();
    }
});
